const BOX_DRAWING = /[╔╗╚╝╠╣╦╩╬║╭╮╯╰┌┐└┘│─]/;

export function formatErrorMessageDisplay(message: string): string {
  if (!message) return message;

  const boxIndex = message.search(BOX_DRAWING);
  if (boxIndex > 0) {
    return message.slice(0, boxIndex).trim();
  }

  const [firstLine] = message.split(/\r?\n/);
  return (firstLine ?? message).trim();
}
